<template>
  <div>
    <div v-if="isMobile()" class="daily-container">
      <img class="bg" src="@/assets/img/daily/DailyBonusLoadingBg.jpg">
      <div class="daily-wrap">
        <div class="play-btn" @click="clickLaunch()">
          <img src="@/assets/img/daily/start_normal.png">
        </div>
        <!-- <a href="#!" @click="clickLaunch()">launch game</a> -->
        <!-- <a href="#!" @click="autoLaounchGame()">auto launch game after 5 second</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import { gameStart } from '@/utils/games'
import { detectMob } from '@/utils/tool'

export default {
  watch: {
    '$store.state.app.inGameId'(newVal, oldVal) {
      if (newVal === null) {
        if (this.$route.query.redirect) {
          // this.url = this.$route.query.redirect
          window.location.href = this.$route.query.redirect
        } else {
          this.$router.push('/')
        }
      }
    },
    '$store.state.app.noticeMessage'(newVal, oldVal) {
      if (newVal === null) {
        // 關閉彈窗
        this.$router.push('/')
      }
    }
  },
  created() {
    if (!detectMob() && this.$route.query.game_obj) {
      const game = JSON.parse(this.$route.query.game_obj)
      gameStart('game', game)
    }
  },
  methods: {
    clickLaunch() {
      const game = JSON.parse(this.$route.query.game_obj)
      gameStart('game', game)
    },
    autoLaounchGame() {
      setTimeout(() => {
        const game = JSON.parse(this.$route.query.game_obj)
        gameStart('game', game)
      }, 5000)
    },
    isMobile() {
      return detectMob()
    }
  }
}

</script>
